import { jsx as _jsx } from "react/jsx-runtime";
import ArticleCardList from "./ArticleCardList";
import Image from "@shared/components/contents/image/Image";
const ArticleCardListPreview = () => {
    return (_jsx(ArticleCardList, { dynamicList: [
            {
                title: "Titre 1",
                image: _jsx(Image, { file: { url: "/exemple-image.jpg" }, disableLazy: true }),
                date: new Date(),
            },
            {
                title: "Titre 2",
                image: _jsx(Image, { file: { url: "/exemple-image.jpg" }, disableLazy: true }),
                date: new Date(),
            },
            {
                title: "Titre 3",
                image: _jsx(Image, { file: { url: "/exemple-image.jpg" }, disableLazy: true }),
                date: new Date(),
            },
        ] }));
};
export default ArticleCardListPreview;
